import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { QueryGet } from '../../types/query-types';
import { RequestService } from '../request/request';
import { Pagination } from '../../models/pagination.interface';
import { Changelog } from '../../models/changelog.interface';

export interface LatestChangelogResponse extends Partial<Changelog> {
  show_modal: boolean;
  isRead?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ChangelogService {
  private apiUrl = environment.service_1 + 'changelog/';

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  private versionSubject = new BehaviorSubject<string>('');
  public version$ = this.versionSubject.asObservable();  
  
  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedchangelog = new BehaviorSubject<Changelog | null>(null);
  selectedchangelog$ = this.selectedchangelog.asObservable();

  private changelogs = new BehaviorSubject<Changelog[]>([]);
  changelog$ = this.changelogs.asObservable();

  setChangelog(changelog: Changelog) {
    this.selectedchangelog.next(changelog);
  }

  setChangelogs(changelogs: Changelog[]) {
    this.changelogs.next(changelogs);
  }

  removeChangelogSelected() {
    this.selectedchangelog.next(null);
  }  

  getlatest(): Observable<LatestChangelogResponse> {
    return this.http.get<LatestChangelogResponse>(`${this.apiUrl}latest/`);
  }

  getLatestVersion(): Observable<{ version: string | null }> {
    return this.http.get<{ version: string | null }>(`${this.apiUrl}version/`).pipe(
      tap((data) => {
        if (data?.version) {
          this.versionSubject.next(data.version);
        }
      })
    );
  }

  MarkasRead(id: number): Observable<unknown> {
    return this.http.patch(`${this.apiUrl}${id}/mark-as-read/`, {});
  }

  getChangelogs(query: QueryGet): Observable<Pagination<Changelog[]>> {
    return this.requestService.get<Changelog[]>(this.apiUrl,query);
  }

  deleteChangelog(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}${id}/`).pipe(
      tap(() => this.getLatestVersion().subscribe())
    );
  }

  createChangelog(payload: any): Observable<any> {
    return this.http.post(this.apiUrl, payload).pipe(
      tap(() => this.getLatestVersion().subscribe())
    );
  } 

  updateChangelog(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.apiUrl}${id}/`, payload).pipe(
      tap(() => this.getLatestVersion().subscribe())
    );
  }
}
